import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { init, api, providers } from '@tripian/core';
import Model from '@tripian/model';
import ICombinedState from '../../redux/model/ICombinedState';
import InitLoading from '../../components/InitLoading/InitLoading';
import App from '../App';
import { clearLocalStorage, getLocalStorageToken } from '../init';
import config from '../../config';
import useAuth from '../../hooks/useAuth';
import useUser from '../../hooks/useUser';
import LOCAL_STORAGE_KEYS from '../../constants/LOCAL_STORAGE_KEYS';
import { changeInitLoading } from '../../redux/action/layout';

interface IAppWrapperStateProps {
  loading: boolean;
}

const AppWrapper = () => {
  const { loading } = useSelector<ICombinedState, IAppWrapperStateProps>((state: ICombinedState) => ({
    loading: state.layout.initLoading,
  }));

  const { userFetch } = useUser();
  const { loggedIn } = useAuth();

  const dispatch = useDispatch();

  useEffect(() => {
    const initial = () => {
      clearLocalStorage();

      const localToken = getLocalStorageToken();
      init(config.TRIPIAN_API_URL, config.TRIPIAN_API_KEY, localToken, false);
      providers.yelpInit();
      if (config.TOUR_PROVIDER_SOURCE === Model.PROVIDER_ID.GLX || config.TICKET_PROVIDER_SOURCE === Model.PROVIDER_ID.GLX) providers.glxInit();
      if (config.TOUR_PROVIDER_SOURCE === Model.PROVIDER_ID.GYG || config.TICKET_PROVIDER_SOURCE === Model.PROVIDER_ID.GYG) providers.gygInit();

      if (localToken) {
        api
          .refreshToken()
          .then((token) => {
            if (!config.DONT_SAVE_TOKEN) localStorage.setItem(`${LOCAL_STORAGE_KEYS.TOKEN}-${config.name}`, JSON.stringify(token));
            userFetch();
            loggedIn();
          })
          .catch(() => {
            // TODO
            // temp dont remove from browser for test..
            // removeLocalStorageToken();
          })
          .finally(() => {
            dispatch(changeInitLoading(false));
          });
      } else {
        dispatch(changeInitLoading(false));
      }
    };

    initial();
  }, [dispatch, loggedIn, userFetch]);

  return <>{loading ? <InitLoading /> : <App />}</>;
};

export default AppWrapper;
